import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { showErrorInNotification, formatMoney } from '../../lib/util';
import { Button, Table, Descriptions, Modal, Spin } from 'antd';
import { Link } from 'react-router-dom';
import ErrorWrapper from '../../lib/error_wrapper';
import ModalTransactionDetail from '../../components/modal_transaction_detail';
import { BasicHeader } from '../../components/basic_header';


const queryString = require('query-string');

const transaction_cols = ({
  onViewDetailClicked
}) => [
    {
      // title: "Type",
      dataIndex: "type",
      key: 'type',
      className: 'center-align',
      width: 53,
      render: (value, row, index) => {
        return <div title={value == 'C' ? "Credit" : (value == 'D' ? "Debit" : "N/A")} className={value === 'D' ? 'debit-circle' : value == 'C' ? 'credit-circle' : 'na-circle'}>
          {value || "-"}
        </div>
      }
    },
    {
      title: "Txn Date",
      dataIndex: "txn_date",
      width: 120,
      key: 'txn_date'
    }, {
      title: "Tran ID",
      dataIndex: "transaction_id",
      width: 100,
      key: 'transaction_id'
    }, {
      title: "Particular",
      dataIndex: "description",
      key: 'description'
    }, {
      title: "Amount",
      dataIndex: "amount",
      width: 120,
      key: 'amount'
    },
    {
      title: "Age(Days)",
      dataIndex: "age",
      width: 100,
      key: 'age'
    },
    {
      title: "",
      dataIndex: "id",
      width: 50,
      key: 'action',
      render: (id) => <Link to={`/processors/${id}`} onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        typeof onViewDetailClicked === 'function' && onViewDetailClicked(id)
      }}><Button type='link' >View</Button></Link>
    }
  ]
class AgingFilteredData extends Component {
  constructor(props) {
    super(props)
    this.reconciler_id = props.match.params.reconciler_id;


    this.state = {
      comp_key: `${Math.random()}`,
      filter_data: {},
      loading: true
    };

    this.list_transaction = RESTExecutor.list().config({
      label: 'aging_filtered_transaction',
      params: {
        per_page: 100
      }
    }).forId(this.reconciler_id).callbacks(() => {
      this.setState({ loading: false })
    }, (error) => {
      showErrorInNotification(error)
      this.setState({ loading: false })
    }).connect(props.domains.reconciliation);
  };

  render() {
    let list_transaction_resp = this.list_transaction.response();
    let rowsData = (list_transaction_resp.result && list_transaction_resp.result.rows) || []
    let rowsMeta = list_transaction_resp.meta || {};
    const { loading } = this.state;
    if (loading) {
      return <center><Spin /></center>
    }

    return (
      <ErrorWrapper
        error={list_transaction_resp}
        onReload={() => {
          this.setState({ loading: true })
          this.list_transaction.forId(this.reconciler_id).execute()
        }}
      >
        <BasicHeader
          title="Unprocessed Transactions"
        />
        <div className='default-card' style={{ padding: 8 }}>
          <Modal
            visible={this.state.view_transaction_modal}
            width={'90%'}
            destroyOnClose
            footer={null}
            centered
            className='transaction-modal'
            onCancel={() => {
              this.setState({
                view_transaction_modal: false,
                view_transaction_id: null
              })
            }}
          >
            <ModalTransactionDetail
              onClose={() => {
                this.setState({
                  view_transaction_modal: false,
                  view_transaction_id: null
                })
              }}
              isModal={true}
              match={{
                params: {
                  transaction_id: this.state.view_transaction_id
                }
              }}
              transaction_id={this.state.view_transaction_id}
            />
          </Modal>

          <Table
            scroll={{ x: true }}
            size='small'
            className='main-table'
            bordered={false}
            loading={list_transaction_resp.fetching}
            columns={transaction_cols({
              onViewDetailClicked: (id) => {
                this.setState({
                  view_transaction_id: id,
                  view_transaction_modal: true
                })
              }
            })}
            rowKey={(record) => `${record.id}`}
            pagination={{
              // simple: true,
              position: 'bottom',
              onChange: (current, size) => {
                this.list_transaction.config({
                  params: {
                    ...this.state.filter_data,
                    per_page: size,
                    page: current
                  }
                }).execute();
              },
              defaultCurrent: 1,
              current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
              // defaultPageSize: 20,
              pageSize: (rowsMeta && rowsMeta.requested_count),

              total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
              showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count, 0)} items`
            }}
            dataSource={rowsData}
            expandedRowRender={(record, index, indent, expanded) => {
              let ours = record || {};
              return <div key={record.id} style={{ display: 'flex', flexDirection: 'column', maxWidth: 'calc(100vw - 400px)', paddingBottom: 16 }}>
                <div>
                  {ours.parsed_data && Object.keys(ours.parsed_data).length > 0 &&
                    <Descriptions title="Parsed Data" className='small-description' bordered size='small' layout='horizontal'>
                      {Object.keys(ours.parsed_data).map((key) => {
                        return <Descriptions.Item key={key} label={key}>{typeof ours.parsed_data[key] === 'string' ? ours.parsed_data[key] : JSON.stringify(ours.parsed_data[key])}</Descriptions.Item>
                      })}
                    </Descriptions>

                  }
                </div>
              </div>
            }}
          />


        </div>
      </ErrorWrapper>
    );
  }

  componentDidMount() {
    let parsed = {}
    if (this.props.location.search) {
      parsed = queryString.parse(this.props.location.search);
      // console.log("parsed filter data",parsed)
      this.setState({
        filter_data: parsed
      })
      this.list_transaction.forId(this.reconciler_id).config({
        params: {
          ...parsed,
          per_page: 100,
          page: 1
        }
      }).execute();

    }
  }

  componentDidUpdate(prevProps) {
    // console.log("Changed state before",this.props.location)

    if ((this.props.location && this.props.location.search !== prevProps.location.search) || this.props.match.params.reconciler_id !== prevProps.match.params.reconciler_id) {
      const parsed = queryString.parse(this.props.location.search);
      // console.log("filter data",parsed)
      this.reconciler_id = this.props.match.params.reconciler_id
      this.setState({
        filter_data: parsed
      })
      this.list_transaction.forId(this.reconciler_id).config({
        params: {
          ...parsed,
          per_page: 100,
          page: 1
        }
      }).execute();
    }
  }
}

export default withDomains(AgingFilteredData, "reconciliation");

